'use strict';

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Any = require('./any');
var internals = {};
internals.Map = /*#__PURE__*/function (_Map) {
  _inherits(_class, _Map);
  function _class() {
    _classCallCheck(this, _class);
    return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
  }
  _createClass(_class, [{
    key: "slice",
    value: function slice() {
      return new internals.Map(this);
    }
  }]);
  return _class;
}(_wrapNativeSuper(Map));
module.exports = Any.extend({
  type: 'symbol',
  terms: {
    map: {
      init: new internals.Map()
    }
  },
  coerce: {
    method: function method(value, _ref) {
      var schema = _ref.schema,
        error = _ref.error;
      var lookup = schema.$_terms.map.get(value);
      if (lookup) {
        value = lookup;
      }
      if (!schema._flags.only || typeof value === 'symbol') {
        return {
          value: value
        };
      }
      return {
        value: value,
        errors: error('symbol.map', {
          map: schema.$_terms.map
        })
      };
    }
  },
  validate: function validate(value, _ref2) {
    var error = _ref2.error;
    if (typeof value !== 'symbol') {
      return {
        value: value,
        errors: error('symbol.base')
      };
    }
  },
  rules: {
    map: {
      method: function method(iterable) {
        if (iterable && !iterable[Symbol.iterator] && typeof iterable === 'object') {
          iterable = Object.entries(iterable);
        }
        Assert(iterable && iterable[Symbol.iterator], 'Iterable must be an iterable or object');
        var obj = this.clone();
        var symbols = [];
        var _iterator = _createForOfIteratorHelper(iterable),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            Assert(entry && entry[Symbol.iterator], 'Entry must be an iterable');
            var _entry = _slicedToArray(entry, 2),
              key = _entry[0],
              value = _entry[1];
            Assert(typeof key !== 'object' && typeof key !== 'function' && typeof key !== 'symbol', 'Key must not be of type object, function, or Symbol');
            Assert(typeof value === 'symbol', 'Value must be a Symbol');
            obj.$_terms.map.set(key, value);
            symbols.push(value);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return obj.valid.apply(obj, symbols);
      }
    }
  },
  manifest: {
    build: function build(obj, desc) {
      if (desc.map) {
        obj = obj.map(desc.map);
      }
      return obj;
    }
  },
  messages: {
    'symbol.base': '{{#label}} must be a symbol',
    'symbol.map': '{{#label}} must be one of {{#map}}'
  }
});